<template lang="pug">
	.app
		Tutorial
		ProjectVersionPreviewList
		ProjectVersionPreviewCreate
		ProjectVersionPreviewDelete
		ProjectSettings
		ProjectActionsDelete
		ProjectVersionActionsDuplicate
		ProjectVersionActionsDelete
		VersionSettings
		CloneProjectRepository
		CloneTemplateRepository
		ProjectCreatePlayable
		ProjectCreatePlayableRequest
		ProjectCreateBanner
		ProjectVersionCreateBanner
		ProjectCreateEndCard
		EndCardSelector
		UploadAmazonS3
		UploadSkyKids
		UploadMraidio
		MonitoringLog
		AssetPreviewMini
		OfferPreviewMini
		DisplayObjectProps
		ProjectPreviewMini
		ItemsDropdown
		AddUser
		Confirm
		ProductFeedChooser
		header.app-header.navbar(v-show="User.loaded && User.currentUser")
			PublisherLogo
			MainMenu
			.online-users(v-if="User.loaded && User.currentUser")
				OnlineUsersHeader
			.right-controls
				TutorialButton
				AccountButton
		.app-body(v-show="User.loaded && User.currentUser")
			.page.preview(v-if="Layout.page === 'playables' || Layout.page === 'banners' || Layout.page === 'end-cards' || Layout.page === 'marker'")
				ProjectsSearchBar
				ToolboxPreview
				LayoutWorkspaceToggler
				ProjectsPlane
				ProjectVersions
				main.main(v-if="Project.loaded && Project.SelectedProject && Project.getOrderedProjectsList(Publisher.SelectedPublisher, Layout.page, Layout.workspace, Layout.projectsFilter).length" :style="{'margin-left': `${Layout.getProjectsPlaneWidth() + Layout.projectsVersionsPlaneWidth}px`}")
					.container-fluid
						Preview
				SettingsPlane(fixed)
					SettingsContent
				.empty-workspace(v-if="Project.loaded && !Project.SelectedProject && !Project.getOrderedProjectsList(Publisher.SelectedPublisher, Layout.page, Layout.workspace, Layout.projectsFilter).length")
					span There are no projects in this workspace
			.page.publisher-list(v-bar v-show="Layout.page === 'publisher-list'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				PublisherList
			.page.publisher-contacts(v-bar v-show="Layout.page === 'publisher-contacts'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				PublisherContacts
			.page.user-list(v-bar v-show="Layout.page === 'user-list'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				UserList
			.page.publisher-settings(v-bar v-show="Layout.page === 'publisher-settings'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				PublisherSettings
			.page.publisher-users(v-bar v-show="Layout.page === 'publisher-users'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				PublisherUsers
			.page.publisher-invitations(v-bar v-show="Layout.page === 'publisher-invitations'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				PublisherInvitations
			.page.publisher-invitations(v-bar v-show="Layout.page === 'user-profile'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				UserProfile
			.page.publisher-invitations(v-bar v-show="Layout.page === 'user-actions-log'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				UserActionsLog
		Auth(v-show="User.loaded && !User.currentUser")
</template>

<script>
	import Screen 									from './../../mixins/screen'

	import ToolboxPreview							from './../../components/Toolbox/ToolboxPreview'
	import Tutorial									from './../../components/Tutorial/Tutorial'

	import Preview 									from './../../components/Preview/Preview'
	import ProjectsSearchBar						from './../../components/Project/ProjectsSearchBar'
	import ProjectsPlane 							from './../../components/Project/ProjectsPlane'
	import ProjectActionsDelete						from './../../components/Project/ProjectActionsDelete'
	import ProjectSettings							from './../../components/Project/ProjectSettings'
	import ProjectVersions 							from './../../components/Project/ProjectVersions'
	import ProjectVersionPreviewList				from './../../components/Project/ProjectVersionPreviewList'
	import ProjectVersionPreviewCreate				from './../../components/Project/ProjectVersionPreviewCreate'
	import ProjectVersionPreviewDelete				from './../../components/Project/ProjectVersionPreviewDelete'

	import ProjectVersionActionsDuplicate 			from './../../components/Dashboard/ProjectVersionActionsDuplicate'
	import ProjectVersionActionsDelete				from './../../components/Dashboard/ProjectVersionActionsDelete'
	import VersionSettings							from './../../components/Dashboard/VersionSettings'
	import CloneProjectRepository					from './../../components/Dashboard/CloneProjectRepository'
	import CloneTemplateRepository					from './../../components/Dashboard/CloneTemplateRepository'
	import ProjectCreatePlayable					from './../../components/Dashboard/ProjectCreatePlayable'
	import ProjectCreatePlayableRequest				from './../../components/Dashboard/ProjectCreatePlayableRequest'
	import ProjectCreateBanner						from './../../components/Dashboard/ProjectCreateBanner'
	import ProjectVersionCreateBanner				from "./../../components/Dashboard/ProjectVersionCreateBanner"
	import ProjectCreateEndCard						from './../../components/Dashboard/ProjectCreateEndCard'
	import EndCardSelector							from './../../components/Dashboard/EndCardSelector'

	import AssetPreviewMini							from './../../components/Dashboard/AssetPreviewMini'
	import OfferPreviewMini							from './../../components/Dashboard/OfferPreviewMini'
	import DisplayObjectProps						from './../../components/Settings/DisplayObjectProps'
	import ProjectPreviewMini						from './../../components/Dashboard/ProjectPreviewMini'
	import ItemsDropdown							from './../../components/Dashboard/ItemsDropdown'
	import Confirm									from './../../components/Dashboard/Confirm'

	import UploadAmazonS3							from './../../components/Dashboard/UploadAmazonS3'
	import UploadSkyKids							from './../../components/Dashboard/UploadSkyKids'
	import UploadMraidio							from './../../components/Dashboard/UploadMraidio'

	import MonitoringLog							from './../../components/Monitoring/MonitoringLog'

	import SettingsPlane 							from './../../components/Settings/SettingsPlane'
	import SettingsContent 							from './../../components/Settings/SettingsContent'
	import ProductFeedChooser						from './../../components/Settings/CustomControls/ProductFeedChooser'

	import MainMenu  								from './../../components/Header/MainMenu'
	import TutorialButton 							from './../../components/Header/TutorialButton'
	import AccountButton 							from './../../components/Header/AccountButton'
	import LayoutWorkspaceToggler					from './../../components/Header/LayoutWorkspaceToggler'
	import OnlineUsersHeader						from './../../components/Header/OnlineUsersHeader'

	import PublisherLogo 							from './../../components/Publisher/PublisherLogo'
	import PublisherList 							from './../../components/Publisher/PublisherList'
	import PublisherContacts						from './../../components/Publisher/PublisherContacts'
	import PublisherSettings						from './../../components/Publisher/PublisherSettings'
	import PublisherUsers 							from './../../components/Publisher/PublisherUsers'
	import PublisherInvitations 					from './../../components/Publisher/PublisherInvitations'

	import Auth 									from './../../components/User/Auth'
	import UserList 								from './../../components/User/UserList'
	import UserProfile								from './../../components/User/UserProfile'
	import AddUser									from './../../components/User/AddUser'
	import UserActionsLog							from './../../components/User/UserActionsLog'

	import { User } 								from './../../services/User'
	import { Publisher } 							from './../../services/Publisher'
	import { Project } 								from './../../services/Project'
	import { Layout } 								from './../../services/Layout'

	export default {
		name: 'Dashboard',
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Workspace Changed", "Layout Page Changed", "Current User Changed", "Current User Loaded", "Selected Project Fully Loaded", "Selected Project Changed", "Selected Publisher Changed", "Publisher Projects Loaded"],
			events: {
				"Layout Page Changed": function() {

					this.$nextTick(() => {

						Broadcast.call("Layout Page Changed Next Tick");

					});

				}
			}
		},
		components: {
			Tutorial,
			ToolboxPreview,
			MainMenu,
			PublisherLogo,
			PublisherList,
			PublisherContacts,
			PublisherSettings,
			PublisherUsers,
			PublisherInvitations,
			TutorialButton,
			AccountButton,
			ProjectsSearchBar,
			ProjectsPlane,
			ProjectActionsDelete,
			ProjectSettings,
			ProjectVersions,
			ProjectVersionPreviewList,
			ProjectVersionPreviewCreate,
			ProjectVersionPreviewDelete,
			ProjectVersionActionsDuplicate,
			ProjectVersionActionsDelete,
			VersionSettings,
			CloneProjectRepository,
			CloneTemplateRepository,
			ProjectCreatePlayable,
			ProjectCreatePlayableRequest,
			ProjectCreateBanner,
			ProjectVersionCreateBanner,
			ProjectCreateEndCard,
			EndCardSelector,
			AssetPreviewMini,
			OfferPreviewMini,
			DisplayObjectProps,
			ProjectPreviewMini,
			ItemsDropdown,
			Confirm,
			UploadAmazonS3,
			UploadSkyKids,
			UploadMraidio,
			MonitoringLog,
			Preview,
			LayoutWorkspaceToggler,
			SettingsPlane,
			SettingsContent,
			ProductFeedChooser,
			OnlineUsersHeader,
			Auth,
			UserList,
			UserProfile,
			AddUser,
			UserActionsLog
		},
		data() {

			this.User = User;
			this.Project = Project;
			this.Publisher = Publisher;
			this.Layout = Layout;

			return {
				showed: true
			};
		},
		methods: {
			collectData() {


			}
		}
	}
</script>

<style lang="sass">

	.app

		.app-body
			margin-top: 0

			.page
				position: relative
				width: 100%

			.main
				position: relative

				.container-fluid
					padding-top: 30px

			.empty-workspace
				position: absolute
				width: 100%
				height: calc(100% - 55px)
				left: 0
				top: 55px
				display: flex
				align-items: center
				justify-content: center

				span
					font-size: 15px
					color: #9da5b1

		header.app-header.navbar
			position: relative
			flex-direction: row
			flex-wrap: nowrap
			justify-content: space-between
			height: 55px
			padding: 0
			margin: 0
			background-color: #3a4149
			border-bottom: 1px solid #23282c
			flex: 0 0 55px

			.navbar-brand
				position: static
				top: auto
				left: auto
				margin-left: 0

			.download-button
				margin-left: auto

			.settings-button
				margin-left: 0

			.left-controls
				display: flex

			.right-controls
				display: flex
				margin-left: auto

			.demo-access
				display: flex
				color: #f86c6b

		.form-control
			color: rgba(255, 255, 255, 0.87)
			background-color: rgba(255, 255, 255, 0.05)
			border-color: rgba(255, 255, 255, 0.09)

			option
				background-color: #34353e

			&:focus
				color: rgba(255, 255, 255, 0.87)
				background-color: rgba(255, 255, 255, 0.05)
				border-color: rgba(255, 255, 255, 0.09)

				option
					background-color: #34353e

		.switch-slider
			background-color: #343b41
			border: 1px solid #23282c

		.custom-select
			cursor: pointer
			color: #fff
			background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
			background-color: #343b41
			border: 1px solid #23282c

			&.selected
				background-color: #4dbd74

	html:not([dir="rtl"]) .aside-menu-show.aside-menu-fixed .main,
	html:not([dir="rtl"]) .aside-menu-show.aside-menu-fixed .app-footer
		margin-right: 390px !important

	html:not([dir="rtl"]) .aside-menu-show.aside-menu-fixed.sub-aside-menu-show .main,
	html:not([dir="rtl"]) .aside-menu-show.aside-menu-fixed.sub-aside-menu-show .app-footer
		margin-right: 690px !important

</style>
